import camundaAPI from '@/services/camunda'

const state = {
  reports: [],
}

const getters = {
  /* eslint-disable no-shadow */
  reports: state => state.reports,
}

const mutations = {
  set(state, { type, value }) {
    state[type] = value
  },
}

const actions = {
  getReports({ commit }) {
    return camundaAPI.user.authorization('report', 'read').then((result) => {
      const reports = []
      result.data.forEach((permission) => {
        try {
          const report = JSON.parse(permission.resourceId)
          reports.push(report)
        } catch (e) {
          // console.log(e)
        }
      })
      commit('set', { type: 'reports', value: reports })
      return reports
    })
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/report.js